<template>
    <div class="text-center mt-5">
        <h1>Registrační formulář vyplněn</h1>
        <p>Děkujeme za vyplnění formuláře. Nyní proběhne Váš proces přijetí.</p>
    </div>
</template>